import { giphyBlue, giphyGreen, giphyDarkGrey, giphyDarkCharcoal } from '@giphy/js-brand'
import React from 'react'
import styled, { css } from 'styled-components'

const Container = styled.div`
    background: #000;
    border-radius: 18px;
    cursor: pointer;
    display: flex;
    height: 34px;
    overflow: hidden;
    position: relative;
    width: 100%;
`

const Option = styled.div<{ active: boolean; isOff: boolean }>`
    color: ${({ active }) => (active ? '#000' : '#FFF')};
    font-size: 16px;
    font-weight: bold;
    line-height: 34px;
    position: relative;
    text-align: center;
    text-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
    transition: color 0.3s ease-out;
    width: 100%;

    ${({ isOff }) =>
        isOff &&
        css`
            color: #fff;
        `}
`

const Gradient = styled.div<{ active: boolean }>`
    background: linear-gradient(45deg, ${giphyDarkGrey} 0%, ${giphyDarkCharcoal} 100%);
    border-radius: inherit;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    transition: transform 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    width: 50%;

    ${({ active }) =>
        active &&
        css`
            background: linear-gradient(45deg, ${giphyBlue} 0%, ${giphyGreen} 100%);
            transform: translate3d(100%, 0, 0);
        `}
`

type Props = {
    className?: string
    isOn: boolean
    onLabel?: string
    offLabel?: string
    onToggle: (isOn: boolean) => void
}

const CreationToolCTAToggle = ({ className, isOn, onLabel = 'On', offLabel = 'Off', onToggle }: Props) => {
    return (
        <Container className={className} onClick={() => onToggle(!isOn)}>
            <Gradient active={isOn} />
            <Option active={!isOn} isOff={true}>
                {offLabel}
            </Option>
            <Option active={isOn} isOff={false}>
                {onLabel}
            </Option>
        </Container>
    )
}

export default CreationToolCTAToggle
